<template>
  <div class="flex flex-col gap-2">
    <h1 class="text-heading-section">{{ title }}</h1>
    <div class="text-body-large">{{ subtitle }}</div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    subtitle: string;
    title: string;
  }>();
</script>
